// BHP-1053: read hooks for the customer feature over Backend2.0. The collection
// is customer-scoped by the backend, so it returns exactly the customers the
// signed-in account may access — the set to switch the active customer among.
import { type UseQueryResult } from '@tanstack/react-query';
import { useCollection } from '../../../shared/api/useHydra';
import type { HydraCollection } from '../../../shared/api/hydra';
import type { Customer } from '../domain/customer';

export function useCustomers(): UseQueryResult<HydraCollection<Customer>> {
  return useCollection<Customer>('customers');
}
